<template>
    <div>
       <b-avatar variant="info" v-if="userAvatar" :src="userAvatar" class="mr-3 avatar avatar-md rounded-circle"></b-avatar>
       <b-avatar variant="primary" v-else :text="userInitials" class="mr-3"></b-avatar>
    </div>
</template>

<script>

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      originalRole: 0,
    };
  },
  created() {
  },
  computed: {
    userAvatar() {
      const userImage = this.user.userPictureUrl ? this.user.userPictureUrl : '';
      return userImage;
    },
    userInitials() {
      const initials = this.user.userFirstName.charAt(0) + this.user.userLastName.charAt(0);
      const userIntials = initials.toUpperCase();
      return userIntials;
    },
  },
  methods: {
  },
};
</script>

<style scoped>
.b-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    flex-shrink: 0;
    width: 2.5rem;
    height: 2.5rem;
    font-size: inherit;
    font-weight: 400;
    line-height: 1;
    max-width: 100%;
    max-height: auto;
    text-align: center;
    overflow: visible;
    position: relative;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.mr-3, .mx-3 {
    margin-right: 1rem!important;
}
.rounded-circle {
    border-radius: 50%!important;
}
.badge-primary {
    color: #fff;
    background-color: #007bff;
}
</style>
